import { render, staticRenderFns } from "./CeilingLampDevicePanel.vue?vue&type=template&id=4221f7af&lang=pug&"
import script from "./CeilingLampDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./CeilingLampDevicePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports